<template>
    <AdminLayout>
      <MainIndex />
      <div class="pb-16"></div>
    </AdminLayout>
  </template>
<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/ticketsDashboard/tickets/MainIndex.vue';

export default {
  name: 'SupportCenterView',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
